import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";

@Component({
  selector: 'page-stdwise-status-progress',
  templateUrl: 'stdwise-status-progress.html',
})
export class StdwiseStatusProgressPage {

  AllDefaultData: any;
  AllData:any;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform: Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.loadvalues();

    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad StdwiseStatusProgressPage');
  }

  loadvalues() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();
    this.AllData = [];
    this.AllDefaultData = [];
    this.service.httpcall('app_web_service/getSTDwise_statuswise?').subscribe(data => {

      this.AllData = data;
      this.AllDefaultData = data['Data'];
      console.log('AllSorceData',this.AllData);
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/stdwise-status-progress/stdwise-status-progress.ts